// The signed-in login's account (agency), as the app uses it:
// { agencyId, name, role, showAdtao, maxPostcodes, features }.

// The most postcodes one scan may search when the account doesn't say
// (agencies.max_postcodes_per_scan; the Worker uses the same default).
export const DEFAULT_MAX_POSTCODES = 50;

// An agency_members row with its agency joined -> the account, or null.
export function accountFromMembership(row) {
  const agency = row && row.agencies;
  if (!agency || !agency.id) return null;
  return {
    agencyId: agency.id,
    name: agency.name || "",
    role: row.role || "member",
    showAdtao: agency.show_adtao === true,
    maxPostcodes: Number.isInteger(agency.max_postcodes_per_scan) ? agency.max_postcodes_per_scan : DEFAULT_MAX_POSTCODES,
    features: agency.features && typeof agency.features === "object" ? agency.features : {},
  };
}

// Whether this account has Industry Audits (agencies.features.industry_audits,
// set in the SQL Editor only; a plan rule later). Only true switches it on.
export function canUseIndustryAudits(account) {
  return Boolean(account && account.features && account.features.industry_audits === true);
}

// The postcode limit for a scan in this account.
export function maxPostcodesFor(account) {
  return account && Number.isInteger(account.maxPostcodes) ? account.maxPostcodes : DEFAULT_MAX_POSTCODES;
}

// Whether this account may see anything AdTao-derived at all (benchmarks).
// agencies.show_adtao: on for DFY Closing only. Not the same thing as the
// later per-call "Hide AdTao benchmarks" switch.
export function canSeeAdtao(account) {
  return Boolean(account && account.showAdtao);
}
